<template>
  <de-layout-content>
    <a-tabs v-model="activeKey">
      <!-- <a-tab-pane key="1" tab="短信消息">
        <txtMsg></txtMsg>
      </a-tab-pane> -->
      <a-tab-pane key="2" tab="系统消息">
        <sysMsg></sysMsg>
      </a-tab-pane>
      <!-- <a-tab-pane key="3" tab="消息模板">
      </a-tab-pane> -->
    </a-tabs>
  </de-layout-content>
</template>

<script>
import txtMsg from './txtMsg'
import sysMsg from './sysMsg'


export default {
  data() {
    return {
      activeKey: "2",
    };
  },
  components: {
    txtMsg,
    sysMsg
  },
  methods: {

  },
  created() {},
};
</script>
<style lang='less' scoped>
</style>
